import { HTTP_GET, WebApiRequest } from "tools/webservice";
import api from "apis/stackCodeSettings";

export const getCustomerStackCodeByLogin = (successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getStackCodes(),
  successCallback,
  errorCallback,
  mountedRef
});
